<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {wholesalerApi} from "@/container";
import Icon from "@/core/components/icon/Icon.vue";
import {computed} from "vue";
import {Skeleton} from "@/core/components/ui/skeleton";

const {data, isLoading} = useSwr(
    'healthcenter/warehouses',
    () => wholesalerApi().getCurrentHealthcenterWarehouses()
);

const firstWarehouse = computed(() => {
    if (!data.value) {
        return null;
    }

    return data.value.find(warehouse => warehouse.rank === 1);
});
</script>

<template>
  <router-link :to="{name: 'disruption-logistics.wholesaler-warehouse-healthcenter'}" class="flex items-baseline gap-2">
    <Icon name="mdi-warehouse" :size="32" />
    <p v-if="!isLoading" class="text-primary text-lg relative">
      {{ firstWarehouse?.wholesalerWarehouse ? `Votre agence : ${firstWarehouse.wholesalerWarehouse.name}` : 'Veuillez sélectionner votre agence' }} <span>
        <Icon name="mdi-pencil" class="relative" :size="16" color="primary" />
      </span>
    </p>
    <Skeleton v-else class="h-4 w-64" />
  </router-link>
</template>

<style scoped>

</style>
